import { render } from "./NotificationDialog.vue?vue&type=template&id=6711a8e4&scoped=true"
import script from "./NotificationDialog.vue?vue&type=script&lang=js"
export * from "./NotificationDialog.vue?vue&type=script&lang=js"

import "./NotificationDialog.vue?vue&type=style&index=0&id=6711a8e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6711a8e4"]])

export default __exports__